export default __webpack_public_path__ + "static/media/Banner.869eba97.jpg";